import type { IViewColorConfig, IViewConfig } from "lola-framework-ui-test";

/** Heading / title color from the design (not the brand green). */
export const TITLE_COLOR = "#051510";

/** Fallback when the partner theme omits `colors.inactived`. */
export const DISABLED_BUTTON_BG = "#979797";

export const errorInitialState = {
  title: null,
  subTitle: null,
  message: null,
  btnText: null,
  isOut: false,
};

export const themeInitialState = {
  font: {
    h1: {
      fontWeight: "400",
      min: "1.75rem",
      max: "2rem",
      lineHeight: "1",
    },
    highlight: {
      fontWeight: "700",
      min: "1.75rem",
      max: "2rem",
      lineHeight: "0.95",
    },
    h2: {
      fontWeight: "600",
      min: "1.25rem",
      max: "1.5rem",
      lineHeight: "1",
    },
    bodycopy: {
      fontWeight: "500",
      min: "1rem",
      max: "1.25rem",
      lineHeight: "1.25rem",
    },
    secondaryCta: {
      fontWeight: "500",
      min: "0.74rem",
      max: "1rem",
      lineHeight: "1",
    },
    footerText: {
      fontWeight: "500",
      min: "0.85rem",
      max: "0.85rem",
      lineHeight: "1",
    },
    mainButtonText: {
      fontWeight: "600",
      min: "1.15rem",
      max: "1.25rem",
      lineHeight: "2rem",
    },
    step: {
      fontWeight: "600",
      min: "0.5rem",
      max: "0.875rem",
      lineHeight: "1",
    },
    fontfamily: "Helvetica",
    fontcdn: "",
  },
  colors: {
    primaryGradient: "#111111",
    secondaryGradient: "#475268",
    secondaryColor: "#252525",
    whiteColor: "#FFFFFF",
    inactived: "#979797",
    errorColor: "#dc251c",
    partnerHighlights: "#ffffff",
    gradientDeg: "180deg",
    primaryGradientPoint: "0%",
    secundaryGradientPoint: "100%",
    primaryMesh: "linear-gradient(180deg, #111111 0%, #475268 100%)",
    gradient: "linear-gradient(180deg, #111111 0%, #475268 100%)",
    lightness: "dark",
  },
};

const baseView: Omit<IViewColorConfig, "viewConfig"> = {
  background: "#fff",
  iconColors: ["#000", "#000"],
  backgroundIcon: "#fff",
  title: "#000",
  subtitile: "#000",
  bodyCopy: "#000",
  footerColor: "#000",
  backgroundBtn: "#000",
  textColorBtn: "#fff",
  stepsColors: "#000",
  dropzoneColors: ["#000", "#000"],
  stepsLabelColor: "#000",
};

export const themeFormattedInitialState: IViewConfig = {
  primaryMeshGradientView: { ...baseView, viewConfig: "primaryMeshGradientView" },
  specialView: { ...baseView, viewConfig: "specialView" },
  dataView: { ...baseView, viewConfig: "dataView" },
  whiteView: { ...baseView, viewConfig: "whiteView" },
  errorView: { ...baseView, viewConfig: "errorView" },
};

export const APP_ROUTES = {
  PHONE_PAGE: "/phone",
  LOADING_PAGE: "/",
  LANDING_PAGE: "/landing-page",
  WELCOME_PAGE: "/welcome-page",
  CASH_DEPOSIT_LANDING_PAGE: "/cash-deposit-landing",
  CIP_REVIEW_PAGE: "/cip-review",
  STORES_MAP_PAGE: "/stores-map",
  HOW_TO_PAY_IN_CASH_PAGE: "/how-to-pay-in-cash",
  STORES_PAGE: "/stores-page",
  CASH_STORES_PAGE: "/cash-stores-page",
  PAYMENT_VERIFICATION_PAGE: "/payment-verification",
  DEPOSIT_ON_THE_WAY_PAGE: "/deposit-on-the-way",
  SUPPORT_PAGE: "/support",
  ERROR_PAGE: "/error-page",
  SESSION_EXPIRED_PAGE: "/session-expired",
  SERVICE_UNAVAILABLE_PAGE: "/service-unavailable",
  MAINTENANCE_PAGE: "/maintenance",
  LEGAL_PAGE: "/legal",
  TERM_DETAIL_PAGE: "/term-detail",
};
